import React, { useState } from "react";
import Image from "next/image";

import IconButton from "@/components/Atoms/Button/IconButton";
import { DesktopContainer, MobileContainer } from "@/components/Atoms/Box";
import DownloadPDFModal from "./DownloadPDFModal";

import Typography from "@/foundation/Typography/V2";
import { classNameGenerator } from "@/utils";

import styles from "./DownloadPDFBanner.module.scss";

interface DownloadPDFBannerProps {
  icon: string;
  title: string;
  ctaTitle: string;
  campaignSlug: string;
}

const DownloadPDFBanner: React.FC<DownloadPDFBannerProps> = ({
  icon,
  title,
  ctaTitle,
  campaignSlug,
}) => {
  const cls = classNameGenerator(styles);

  const [openDownloadPDFModal, setOpenDownloadPDFModal] = useState(false);

  return (
    <>
      <div
        id="download-pdf-banner"
        className={cls("downloadPDFBanner")}
        onClick={() => setOpenDownloadPDFModal(true)}
      >
        <div className={cls("container")}>
          <div className={cls("leftSection")}>
            <div className={cls("iconWrapper")}>
              <Image
                className={cls("icon")}
                src={icon}
                alt="downloadPDFBanner"
                fill
              />
            </div>
            <Typography variant="heading3" className={cls("title")}>
              Download our complete guide to {title}
            </Typography>
          </div>
          <div className={cls("rightSection")}>
            <DesktopContainer>
              <IconButton
                icon="icon-download-pdf"
                iconHeight="24px"
                iconWidth="24px"
                iconMargin="8px"
                onClick={() => setOpenDownloadPDFModal(true)}
                typographyVariant="paragraph1"
                className={cls("downloadButton")}
              >
                {ctaTitle}
              </IconButton>
            </DesktopContainer>
            <MobileContainer>
              <IconButton
                icon="icon-arrow-right"
                iconHeight="28px"
                iconWidth="28px"
                onClick={() => setOpenDownloadPDFModal(true)}
                className={cls("downloadIconButton")}
              />
            </MobileContainer>
          </div>
        </div>
      </div>
      {openDownloadPDFModal && (
        <DownloadPDFModal
          title={title}
          onClose={() => setOpenDownloadPDFModal(false)}
          campaignSlug={campaignSlug}
        />
      )}
    </>
  );
};

export default DownloadPDFBanner;
